/*
 * Fluevog hero — video sync.
 *
 * The sliding, autoplay, drag, arrows and pagination all come from the theme's
 * <slideshow-component> (assets/slideshow.js). The one thing it doesn't do is
 * touch <video> elements, so a hero with several video slides would play them
 * all at once. This keeps playback to the slide that's actually on screen.
 */
class FluevogHero extends HTMLElement {
  connectedCallback() {
    this.onSelect = this.onSelect.bind(this);
    this.addEventListener('slideshow:select', this.onSelect);

    this.sync(this.querySelector('slideshow-slide'));
  }

  disconnectedCallback() {
    this.removeEventListener('slideshow:select', this.onSelect);
  }

  /** @param {Event} event */
  onSelect(event) {
    const detail = /** @type {{ slide?: Element }} */ (
      /** @type {any} */ (event).detail
    );
    this.sync(detail?.slide ?? null);
  }

  /** @param {Element | null} active */
  sync(active) {
    for (const video of this.querySelectorAll('video')) {
      if (active?.contains(video)) {
        video.play()?.catch(() => {});
      } else {
        video.pause();
      }
    }
  }
}

if (!customElements.get('fv-hero')) {
  customElements.define('fv-hero', FluevogHero);
}
